import { render, staticRenderFns } from "./RuleInfo.vue?vue&type=template&id=49fd1b63&scoped=true"
import script from "./RuleInfo.vue?vue&type=script&lang=js"
export * from "./RuleInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fd1b63",
  null
  
)

export default component.exports